<template>
  <div class="col">
    <div class="row">
      <h2>Recherche par ID</h2>
    </div>
    <div class="row">
      <input
        id="filter"
        v-model="id"
        type="text"
        class="field filter-field"
        placeholder="ID de la pièce"
      >
    </div>
    <div class="row">
      <custom-button @click.native="goToDetails">
        <i class="icon fas fa-search"></i>Rechercher
      </custom-button>
    </div>
  </div>
</template>

<script>
  import CustomButton from './micro-components/custom-button';

  export default {
    name: 'SearchById',
    components: { CustomButton },
    data() {
      return {
        id: null,
      };
    },
    methods: {
      goToDetails() {
        this.$router.push({ name: 'details', params: { id: this.id } });
      }
    }
  };
</script>

<style scoped>
    h2 {
        margin: 0;
    }

    .row {
        justify-content: center;
        margin-top: 0.7em;
    }

    .field {
        text-align: center;
        max-width: 250px;
    }

    .icon {
        margin-right: 0.3em;
    }
</style>
